/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const getImages = params => hmsAPI.get('/images', { params })
export const getImage = imageId => hmsAPI.get(`/images/${imageId}`)
export const putImage = (imageId, data) => hmsAPI.put(`/images/${imageId}`, data)
export const deleteImage = imageId => hmsAPI.delete(`/images/${imageId}`)
export const postImageLines = (imageId, data) => hmsAPI.post(`/favorites/lines/${imageId}`, data)
export const getImagePreviousNext = (raceId, imageId, params) => hmsAPI.get(`/raceimages/${raceId}/images/${imageId}`, {params})
export const updateImageLines = (imageId, data) => hmsAPI.post(`/images/${imageId}/lines`, data)
